export default "__VITE_ASSET__Bqc8MY1Y__"